import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { laborHoursConstant } from 'src/redux/actions/constant';
import laborHoursService from 'src/services/apiServices/laborHoursService/laborHoursService';

function* getLaborCodes(action: any): SagaReturnType<any> {
  try {
    yield put({ type: laborHoursConstant.GET_LABOR_HOURS_LOADER });
    const response = yield call(laborHoursService.getLaborCodesList);
    if (response?.status === 200) {
      yield put({ type: laborHoursConstant.GET_LABOR_CODES_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: laborHoursConstant.GET_LABOR_CODES_FAILURE, payload: error });
  }
}

function* getLaborCodesSaga() {
  yield takeEvery(laborHoursConstant.GET_LABOR_CODES_REQUEST, getLaborCodes);
}

export default getLaborCodesSaga;
